import OneToOneDiscussion from './OneToOneDiscussionContainer';

export default OneToOneDiscussion;
